import { SelectFieldRegulationCP } from "common/components/form/SelectFieldRegulationCP";
import { SelectLocationCP } from "common/components/form/SelectLocationCP";
import React, { useEffect } from "react";
import { ButtonCP } from "submodules/nerit-framework-ui/common/components/button/ButtonCP";
import { DateRangePickerCP } from "submodules/nerit-framework-ui/common/components/form-fields/date-range-picker/DateRangePickerCP";
import { ColumnCP } from "submodules/nerit-framework-ui/common/components/grid/column/ColumnCP";
import { RowCP } from "submodules/nerit-framework-ui/common/components/grid/row/RowCP";
import { IFormStateManager } from "submodules/nerit-framework-ui/common/form-state-manager/types/IFormStateManager";
import { useRequest } from "submodules/nerit-framework-ui/common/request-manager/use-request/UseRequest";
import { ChartsRequests } from "submodules/nerit-aquatec-sdk/services/charts/ChartsRequests";
import { RequestUtils } from "submodules/nerit-framework-utils/sdk-utils/request-manager/RequestUtils";
import { NotificationHelper } from "submodules/nerit-framework-ui/common/components/notification/inner/NotificationHelper";
import { SamplingDataResponseDTO } from "submodules/nerit-aquatec-sdk/services/charts/dtos/responses/SamplingDataResponseDTO";
import { WrapperFiltersCP } from "submodules/nerit-framework-ui/features/common/components/filters/wrapper-filters/WrapperFiltersCP";
import { NonConformityChartFiltersFormModel } from "./inner/NonConformityChartFiltersFormModel";
import { SelectSamplingsCP } from "modules/samplings/components/select-samplings/SelectSamplingsCP";
import { useEnterKeySearch } from "submodules/nerit-framework-ui/common/responsiveness/use-enter-key-search/UseEnterKeySearch";

interface ICPProps {
  formStateManager: IFormStateManager<NonConformityChartFiltersFormModel>;
  onFilter: () => void;
  isLoading?: boolean;
  onSamplingDataLoaded?: () => void;
}

/**
 */
export function FiltersNonConformityChartCP(props: ICPProps): JSX.Element {
  const getSamplingDataRequest = useRequest<SamplingDataResponseDTO>();
  useEffect(onGetSamplingDataRequestChange, [
    getSamplingDataRequest.isAwaiting,
  ]);

  useEffect(
    onSelectSampling,
    [props.formStateManager.getFieldValue("samplingCode")],
  );

  useEnterKeySearch (props.onFilter)

  /**
   */
  function onSelectSampling(): void {
    const samplingCode = props.formStateManager.getFieldValue("samplingCode");
    if (!samplingCode) return;

    getSamplingDataRequest.runRequest(
      ChartsRequests.getSamplingData(samplingCode),
    );
  }

  /**
   */
  function onGetSamplingDataRequestChange(): void {
    if (
      !RequestUtils.isValidRequestReturn(
        getSamplingDataRequest,
        NotificationHelper.DEFAULT_ERROR_GET_MESSAGE,
      )
    )
      return;

    const result = getSamplingDataRequest.responseData!;
    props.formStateManager.changeFieldValue(
      "locationCodes",
      result.locations.map((location) => location.code),
    );

    // Notifica que os dados da campanha foram carregados
    if (props.onSamplingDataLoaded) {
      props.onSamplingDataLoaded();
    }
  }

  return (
    <WrapperFiltersCP
      filters={
        <RowCP>
          <ColumnCP size={6}>
            <SelectLocationCP
              isMany={true}
              formStateManager={props.formStateManager}
              fieldName={"locationCodes"}
              isRequired={true}
              maxTagCount={1}
            />
          </ColumnCP>
          <ColumnCP size={6}>
            <SelectFieldRegulationCP
              isRequired={true}
              formStateManager={props.formStateManager}
              fieldName={"fieldRegulationCode"}
            />
          </ColumnCP>
          <ColumnCP size={6}>
            <DateRangePickerCP
              showBorder={true}
              marginTop={23}
              fastFilter={"all"}
              fieldName={"dateRange"}
              formStateManager={props.formStateManager}
            />
          </ColumnCP>
          <ColumnCP size={6}>
            <SelectSamplingsCP
              formStateManager={props.formStateManager}
              fieldName={"samplingCode"}
              width={200}
            />
          </ColumnCP>
        </RowCP>
      }
      filterButton={
        <ButtonCP
          icon={"search"}
          type={"primary"}
          onClick={props.onFilter}
          loading={props.isLoading}
        />
      }
    />
  );
}
